module.exports = __webpack_public_path__ + "static/media/stop.04cc21c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/stop.svg
// module id = 754
// module chunks = 0